import './App.css';
import Admins from './components/Admins';
import Auth from './components/Auth';
import Events from './components/Events';
import Main from './components/Main';
import QRScan from './components/QRScan';
import Users from './components/Users';

import { Route, Routes, useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LightRays from './components/LightRays';
import API from './APIs/AdminApi';
import LiquidButton from './Blocks/LiquidButton';
import LiquidRoundButton from './Blocks/LiquidRoundButton';

function App() {
  const navigate = useNavigate()
  const location = useLocation()

  const [cookies, setCookie, removeCookie] = useCookies(['adminData']);
  const [adminData, setAdminData] = useState(null)
  
  useEffect(() => {
    
    if(!cookies.adminData || !cookies?.adminData?.login || !cookies?.adminData?.password){
    navigate('/auth')
  }
  }, [])

  useEffect(() => {
    if(adminData != null) return;
    if(!cookies?.adminData?.login || !cookies?.adminData?.password) return;
    let adminDataRow = {
      login: cookies?.adminData?.login,
      password: cookies?.adminData?.password
    }
    API.LoadAdmin(adminDataRow).then((data) => {
      if(data.status == 200){
        setAdminData(data.res.data)
      }
    }).catch((e) => console.error(e))
    
    
  }, [adminData])

  return (
    <div className="App">
      <LightRays
        raysOrigin="top-center"
        raysColor="#ff0000"
        raysSpeed={1.5}
        lightSpread={4.8}
        rayLength={8.2}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0.1}
        distortion={0.45}
        className="custom-rays" />
        <div className="controllerMenu">
          {location.pathname != '/' ? <LiquidRoundButton onClick={() => navigate('/')}>←</LiquidRoundButton> : null}
          {!cookies.adminData || !cookies?.adminData?.login || !cookies?.adminData?.password ? null : <button className='logOutButton' onClick={() => {
            removeCookie('adminData')
            navigate('/auth')
            }}>Выйти</button>}
        </div>
      <Routes className="container">
        <Route index path="/" element={<Main adminData={adminData}/>}/>
        <Route path="/auth" element={<Auth setCookie={setCookie} cookies={cookies} setAdminData={setAdminData}/>}/>
        <Route path="/admins" element={<Admins adminData={adminData}/>}/>
        <Route path="/events" element={<Events adminData={adminData}/>}/>
        <Route path="/users" element={<Users adminData={adminData}/>}/>
        <Route path="/qrscan" element={<QRScan adminData={adminData}/>}/>
      </Routes>
    </div>
  );
}

export default App;
